import { BP, Colors, Mixins, mq, mqHover, mqMax } from '~/styles';
import { baseButton, disabled, label } from '~/styles/button';
import type { TStyleSheet, TStyles } from '~/types/emotion-styles';

export const buttonSizeStyles = (size: number): TStyles => ({
  height: size,
  width: size,
});

const styles: TStyleSheet = {
  baseButton,
  iconButton: {
    ...Mixins.accessibleMinButtonSize(),
    ...Mixins.transition(['color', 'background-color']),
    alignSelf: 'center',
    borderRadius: '100%',
  },
  defaultDarkTheme: {
    color: Colors.white,
    ...mqHover({
      color: Colors.white60,
    }),
  },
  defaultLightTheme: {
    color: Colors.audacyDarkNavy,
    ...mqHover({
      color: Colors.audacyDarkNavy60,
    }),
  },
  fillDarkTheme: {
    backgroundColor: Colors.white,
    color: Colors.audacyDarkNavy,
    ...mqHover({
      color: Colors.audacyDarkNavy60,
    }),
  },
  fillLightTheme: {
    backgroundColor: Colors.audacyDarkNavy,
    color: Colors.white,
    ...mqHover({
      color: Colors.white60,
    }),
  },
  hoverFillDarkTheme: {
    backgroundColor: 'transparent',
    color: Colors.white,
    ...mqHover({
      backgroundColor: Colors.white15,
      color: Colors.white60,
    }),
  },
  hoverFillLightTheme: {
    backgroundColor: 'transparent',
    color: Colors.audacyDarkNavy,
    ...mqHover({
      backgroundColor: Colors.audacyDarkNavy,
      color: Colors.white60,
    }),
  },
  outlineDarkTheme: {
    background: 'transparent',
    boxShadow: `0 0 0 1px ${Colors.white30}`,
    color: Colors.white,
    ...mqHover({
      color: Colors.white60,
    }),
  },
  outlineLightTheme: {
    background: 'transparent',
    boxShadow: `0 0 0 1px ${Colors.audacyDarkNavy60}`,
    color: Colors.audacyDarkNavy,
    ...mqHover({
      color: Colors.audacyDarkNavy60,
    }),
  },
  disabled,
  children: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },
  label: {
    ...label,
    overflow: 'visible',
    fontWeight: '700',
    fontSize: '1.5rem',
    lineHeight: '1.3',
    [mqMax(BP.Medium)]: {
      fontSize: '1rem',
    },
  },
};

export default styles;
